module.exports = __webpack_public_path__ + "img/missionaries10_2019_7-7-2021.7986f077.jpg";